import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL, UPLOADS_BASE_URL } from "../../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./appraisalWizard.css";

const OthersAppraisalEvaluate = () => {
  const { requestId } = useParams();
  const history = useHistory();

  const [data, setData] = useState(null);
  const [answers, setAnswers] = useState({});
  const [step, setStep] = useState(0);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/appraisal/evaluate/${requestId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((res) => {
        if (res.data.expired) {
          toast.error("Appraisal request expired");
          setTimeout(() => history.push("/OthersAppraisalList"), 1500);
          return;
        }
        setData(res.data);
      })
      .catch(() => toast.error("Failed to load appraisal"));
  }, [requestId, history]);

  if (!data) return <div className="card p-4 text-center">Loading...</div>;

  /* ================= VIEW MODE ================= */
  if (data.is_answerd === 1) {
    return (
      <div className="card">
        <ToastContainer position="top-right" autoClose={3000} />

        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Others Appraisal Score</h5>
          <button
            className="btn btn-primary"
            onClick={() => history.push("/OthersAppraisalList")}
          >
            Back
          </button>
        </div>

        <div className="card-body" style={{ backgroundColor: "#f2f2f2" }}>
          <div className="row">
            <div className="col-md-7 mb-3">
              <div className="p-3 bg-white">
                <h4>
                  Total Rating Score :
                  <span className="text-danger"> {data.score.total_score}</span>
                </h4>
                <h4>
                  Threshold :
                  <span className="text-primary"> {data.score.threshold}</span>
                </h4>
              </div>
            </div>

            <div className="col-md-5 mb-3">
              <div className="p-3 bg-white">
                <h4>
                  Performance Bucket :
                  <span className="text-danger"> {data.score.grade}</span>
                </h4>
                <h4>&nbsp;</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ================= EVALUATE MODE ================= */
  const questions = data.questions || [];
  const total = questions.length;
  const isConfirmStep = step === total;
  const current = questions[step];

  const info = data.info || {};
  const LOGO_URL = `${UPLOADS_BASE_URL}/uploads/logo/payroll/annai_arul_logo.jpg`;
  const profilePicUrl = info.profile_picture
    ? `${UPLOADS_BASE_URL}/uploads/profile/${info.profile_picture}`
    : LOGO_URL;

  /* Progress mirrors the CI wizard: one step per question plus the confirm step */
  const progress = Math.round((100 / (total + 1)) * (step + 1));

  /* ================= SUBMIT ================= */
  const submit = () => {
    if (Object.keys(answers).length !== total) {
      toast.error("Please answer all questions");
      return;
    }

    if (comment.trim() === "") {
      toast.error("Comment field cannot be empty.");
      return;
    }

    setSubmitting(true);

    axios
      .post(
        `${API_BASE_URL}/appraisal/evaluate/submit`,
        {
          request_id: requestId,
          employee_id: info.sent_to,
          comment: comment.trim(),
          answers: Object.values(answers),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.message || "Appraisal submitted successfully");
        setTimeout(() => history.push("/OthersAppraisalList"), 1500);
      })
      .catch(() => {
        toast.error("Submission failed. Please try again");
        setSubmitting(false);
      });
  };

  return (
    <div className="card">
      <ToastContainer position="bottom-right" />

      <div className="card-header d-flex justify-content-between align-items-center">
        <span className="card-header-title mr-2">Self Appraisal form</span>
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => history.push("/OthersAppraisalList")}
        >
          Back
        </button>
      </div>

      <div className="card-body">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4 text-center mb-3">
              <img
                src={profilePicUrl}
                alt="Profile"
                className="appraisal-emp-photo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = LOGO_URL;
                }}
              />
            </div>
            <div className="col-md-8">
              <p>
                Employee Name :{" "}
                <span className="appraisal-emp-value">
                  {info.employee_name}
                </span>
              </p>
              <p>
                Employee ID :{" "}
                <span className="appraisal-emp-value">{info.employee_id}</span>
              </p>
              <p>
                Department :{" "}
                <span className="appraisal-emp-value">
                  {info.department_name}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-lg-8 col-md-10 text-center p-0 mb-2">
                  <div className="wizardbox px-0 pt-4 pb-0 mt-3 mb-3">
                    <div className="appraisal-wizard">
                      <div className="progress">
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          aria-valuenow={progress}
                          style={{ width: `${progress}%` }}
                        />
                      </div>
                      <br />

                      {!isConfirmStep ? (
                        <fieldset className="quest">
                          <div className="form-card">
                            <div className="row">
                              <div className="col-12">
                                <h5 className="steps">
                                  Questions {step + 1} - {total}
                                </h5>
                              </div>
                              <div className="col-12">
                                <h2 className="fs-title">
                                  {current.question_title}
                                </h2>
                              </div>
                            </div>

                            <div className="row">
                              {current.options.map((o) => (
                                <React.Fragment key={o.value_id}>
                                  <div className="col-2">
                                    <input
                                      type="radio"
                                      className="selfradio"
                                      name={`question_${current.question_id}`}
                                      checked={
                                        answers[current.question_id]
                                          ?.option_id === o.value_id
                                      }
                                      onChange={() =>
                                        setAnswers({
                                          ...answers,
                                          [current.question_id]: {
                                            question_id: current.question_id,
                                            option_id: o.value_id,
                                            score: o.score,
                                          },
                                        })
                                      }
                                    />
                                  </div>
                                  <div className="col-10 mb-2">
                                    <label className="fieldlabels">
                                      {o.value_title}
                                    </label>
                                  </div>
                                </React.Fragment>
                              ))}
                            </div>
                          </div>

                          <input
                            type="button"
                            className="action-button"
                            value="Next"
                            onClick={() => {
                              if (!answers[current.question_id]) {
                                toast.error(
                                  "Please select a correct answer for this question."
                                );
                                return;
                              }
                              setStep(step + 1);
                            }}
                          />
                          {step > 0 && (
                            <input
                              type="button"
                              className="action-button-previous"
                              value="Previous"
                              onClick={() => setStep(step - 1)}
                            />
                          )}
                        </fieldset>
                      ) : (
                        <fieldset>
                          <div className="form-card">
                            <div className="row">
                              <div className="col-12">
                                <label
                                  className="fieldlabels"
                                  style={{
                                    display: "block",
                                    textAlign: "center",
                                    width: "100%",
                                  }}
                                >
                                  Comment
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  name="commt"
                                  value={comment}
                                  onChange={(e) => setComment(e.target.value)}
                                />
                              </div>
                              <div className="col-12">
                                <h2 className="fs-title">Are you sure?</h2>
                              </div>
                            </div>

                            <div className="row align-items-center">
                              <div className="col-6">
                                <h2>Confirm to send.!</h2>
                              </div>
                              <div className="col-6">
                                <input
                                  type="button"
                                  className="action-button"
                                  value={submitting ? "Sending..." : "Submit"}
                                  disabled={submitting}
                                  onClick={submit}
                                />
                              </div>
                            </div>
                          </div>

                          <input
                            type="button"
                            className="action-button"
                            value="Cancel"
                            disabled={submitting}
                            onClick={() => history.push("/OthersAppraisalList")}
                          />
                          <input
                            type="button"
                            className="action-button-previous"
                            value="Previous"
                            disabled={submitting}
                            onClick={() => setStep(step - 1)}
                          />
                        </fieldset>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OthersAppraisalEvaluate;
